export default {"src":"/_next/static/media/music-producer.42d35d95.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};